import type { Bcp47Locale } from '@backmarket/http-api/src/standards/Locale'

export default function createCountryFormatter(locale: Bcp47Locale) {
  return (countryCode: string) => {
    if (typeof Intl.DisplayNames !== 'function') {
      return countryCode
    }

    const regionNames = new Intl.DisplayNames([locale], {
      type: 'region',
    })

    return regionNames.of(countryCode) || countryCode
  }
}
